export default "__VITE_ASSET__zxeQCn0Y__"